import { signOut } from "aws-amplify/auth";
import { http } from "./http";

const buildRevokeCookieErrorContext = (
  error: unknown,
): Record<string, unknown> => {
  const context: Record<string, unknown> = {
    endpoint: "/media-access/cookies",
    method: "DELETE",
  };

  if (typeof error === "object" && error !== null) {
    const e = error as Record<string, unknown>;
    if (typeof e.status === "number") context.status = e.status;
    if (typeof e.title === "string") context.title = e.title;
    if (typeof e.detail === "string") context.detail = e.detail;
    if (typeof e.code === "string") context.code = e.code;
  } else {
    context.error = String(error);
  }

  return context;
};

async function revokeMediaAccessCookies(): Promise<void> {
  try {
    await http("/media-access/cookies", { method: "DELETE" });
  } catch (error) {
    // Logout should proceed even when cookie revoke fails.
    console.warn(
      "Failed to revoke media access cookies",
      buildRevokeCookieErrorContext(error),
      error,
    );
  }
}

export async function signOutWithMediaCookieRevoke(): Promise<void> {
  await revokeMediaAccessCookies();
  await signOut();
}
